// Mock data for Birchfield Roofing LLC

export const companyInfo = {
  name: "Birchfield Roofing LLC",
  tagline: "Family Owned & Operated Since Day One",
  phones: [
    { number: "(352) 705-2921", name: "Claire" },
    { number: "(407) 399-6992", name: "Gary" }
  ],
  email: "birchfieldconstruction101@gmail.com",
  serviceArea: "Central Florida",
  licensed: true,
  insured: true
};

export const services = [
  {
    id: 1,
    title: "Metal Roofing",
    description: "Durable, energy-efficient metal roofing systems designed to withstand Florida's harsh weather conditions.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1602193458517-db6caca8f1fe"
  },
  {
    id: 2,
    title: "Shingle Roofing",
    description: "Premium asphalt and architectural shingles offering excellent protection and curb appeal for your home.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1755114203680-d39d95efa82c"
  },
  {
    id: 3,
    title: "Tile Roofing",
    description: "Classic tile roofing solutions that provide superior durability and timeless beauty for Central Florida homes.",
    icon: "Layers",
    image: "https://images.unsplash.com/photo-1563993356056-b23a9cd265ad"
  },
  {
    id: 4,
    title: "Roof Repairs",
    description: "Expert roof repair services to fix leaks, damage, and wear before they become major problems.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1610056868457-e61d6f9eeb86"
  },
  {
    id: 5,
    title: "Roof Inspection",
    description: "Comprehensive roof inspections to assess condition and identify potential issues early.",
    icon: "Search",
    image: "https://images.unsplash.com/photo-1632759145351-1d592919f522"
  },
  {
    id: 6,
    title: "Emergency Services",
    description: "24/7 emergency roofing services for storm damage and urgent repairs throughout Central Florida.",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Family Owned & Operated",
    description: "As a family business, we treat every project with personal care and attention to detail.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Licensed & Insured",
    description: "Fully licensed and insured for your peace of mind and protection.",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Quality Workmanship",
    description: "We use only premium materials and proven techniques for lasting results.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Local Expertise",
    description: "Deep understanding of Central Florida's unique roofing challenges and weather conditions.",
    icon: "MapPin"
  },
  {
    id: 5,
    title: "Free Estimates",
    description: "No-obligation, detailed estimates for all roofing projects, big or small.",
    icon: "FileText"
  },
  {
    id: 6,
    title: "Customer Satisfaction",
    description: "Your satisfaction is our priority. We're not done until you're completely happy.",
    icon: "Heart"
  }
];

export const serviceAreas = [
  "Marion County",
  "Lake County",
  "Orange County",
  "Seminole County",
  "Osceola County",
  "Polk County",
  "Volusia County",
  "Brevard County",
  "Citrus County",
  "Hernando County",
  "Pasco County",
  "Sumter County"
];

export const testimonials = [
  {
    id: 1,
    name: "John & Sarah Martinez",
    location: "Ocala, FL",
    rating: 5,
    text: "Birchfield Roofing replaced our old shingle roof with a beautiful metal roof. The team was professional, efficient, and cleaned up perfectly. Highly recommend!"
  },
  {
    id: 2,
    name: "Robert Thompson",
    location: "The Villages, FL",
    rating: 5,
    text: "After storm damage, they responded quickly and got our roof repaired within days. Fair pricing and excellent work. True professionals."
  },
  {
    id: 3,
    name: "Linda Chen",
    location: "Gainesville, FL",
    rating: 5,
    text: "We had a tile roof installed and it looks amazing! The family-owned touch really shows in their attention to detail. Worth every penny."
  }
];
